import { ModalFooter } from '@ds';
import { IoMdTimer } from 'react-icons/io';
import { MdAccessTime, MdOutlineDateRange } from 'react-icons/md';
import { formatClinicalTime } from '@features/components/ClinicalData/utils';
import { ClinicalMediaType } from '@/api/apis/case';
import { formatTimestamp } from '@/utils/helpers';

type MediaPreviewFooterProps = {
  currentMedia: ClinicalMediaType;
};

export const MediaPreviewFooter = ({ currentMedia }: MediaPreviewFooterProps) => {
  return (
    <ModalFooter className="relative h-16 shrink-0">
      <div className="absolute inset-0 bg-black opacity-50" />
      <div className="relative z-10 flex w-full items-center justify-between px-4">
        <span className="text-sm font-semibold text-white">
          {currentMedia.file.details || 'Details not available.'}
        </span>

        <div className="flex flex-row gap-6">
          {!!currentMedia.ocsTime && (
            <span className="flex flex-row items-center gap-2 text-sm font-semibold text-white">
              <IoMdTimer /> {currentMedia.ocsTime} Perfusion Time
            </span>
          )}

          {!!currentMedia.timestamp && (
            <>
              <span className="flex flex-row items-center gap-2 text-sm font-semibold text-white">
                <MdOutlineDateRange />
                {formatTimestamp(currentMedia.timestamp, currentMedia.timeZone, 'MM/dd/yyyy')}
              </span>

              <span className="flex flex-row items-center gap-2 text-sm font-semibold text-white">
                <MdAccessTime />
                {formatClinicalTime(currentMedia.timestamp, currentMedia.timeZone)}
              </span>
            </>
          )}
        </div>
      </div>
    </ModalFooter>
  );
};
